/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserInvitationDto } from '../../models/user-invitation-dto';

export interface GetUserInvitation$Params {
  invitationCode: string;
}

export function getUserInvitation(http: HttpClient, rootUrl: string, params: GetUserInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<UserInvitationDto>> {
  const rb = new RequestBuilder(rootUrl, getUserInvitation.PATH, 'get');
  if (params) {
    rb.path('invitationCode', params.invitationCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserInvitationDto>;
    })
  );
}

getUserInvitation.PATH = '/api/user/invitation/{invitationCode}';
